import React from 'react';
import CountUp from "react-countup";
import { useInView } from 'react-intersection-observer';
import { motion } from "framer-motion";
import { fadeIn } from "../variants";
import { Link } from 'react-scroll';
import Img from "../assets/Movses_Avatar.png";

const About = () => {
  const [ref, inView] = useInView({threshold: 0.5});

  return (
      <section className='section pb-[100px]' id='about' ref={ref}>
        <div className="container mx-auto">
          <div className='flex flex-col gap-y-10 lg:flex-row lg:items-center lg:gap-x-20 lg:gap-y-0 h-auto'>
            <motion.div 
              variants={fadeIn('right', 0.3)}
              initial="hidden"
              whileInView={'show'}
              viewport={{ once: false, amount: 0.3}}
              className='flex justify-center items-center flex-1'>
                <img src={Img} alt="#" className='object-contain'/>
            </motion.div>
            
            <motion.div 
            variants={fadeIn('left', 0.5)}
            initial="hidden"
            whileInView={'show'}
            viewport={{ once: false, amount: 0.3}}
            className='flex-1'>
              <h2 className='h2 text-accent'>About me.</h2>
              <h3 className='h3 mb-4'>I'm a Freelancer Frontend developer with over 3+ years of experince.</h3>
              <p className='mb-6'>My principal approach is to transfer user problems into frontend challenges and create innovative and usable solutions that will make people's life experience better, more productive, happier.</p>
              
              <div className='flex gap-x-6 lg:gap-x-10 mb-12'>
                <div>
                  <div className='text-[40px] font-tertiary text-gradient mb-2'>
                    {inView ? <CountUp start={0} end={3} duration={1} /> : null}
                    +
                  </div>
                  <div className='font-primary text-sm tracking-[2px]'>
                    Years of <br />
                    Experience
                  </div>
                </div>
                <div>
                  <div className='text-[40px] font-tertiary text-gradient mb-2'>
                    {inView ? <CountUp start={0} end={10} duration={1} /> : null}
                    +
                  </div>
                  <div className='font-primary text-sm tracking-[2px]'>
                    Projects <br />
                    Completed
                  </div>
                </div>
                <div>
                  <div className='text-[40px] font-tertiary text-gradient mb-2'>
                    {inView ? <CountUp start={0} end={10} duration={1} /> : null}
                    +
                  </div>
                  <div className='font-primary text-sm tracking-[2px]'>
                    Satisfied <br />
                    Clients
                  </div>
                </div>
              </div>
              <div className='flex gap-x-8 items-center'>
                <Link to="contact" activeClass='active' smooth={true} spy={true} className='flex justify-center items-center cursor-pointer btn btn-lg'>Contact</Link>
                <Link to='work' activeClass='active' smooth={true} spy={true} className='text-gradient cursor-pointer btn-link'>My Portfolio</Link>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    )
};

export default About;
